/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetFilterRegion {
    getFixupPrototypeFunction() { return BudgetFilterRegion.fixupPrototype; }

    static newInstance(model: Partial<BudgetFilterRegion>): BudgetFilterRegion {
        let obj = Object.assign(new BudgetFilterRegion(), model);
        BudgetFilterRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetFilterRegion>): BudgetFilterRegion {
        if (!model) return null;
        return BudgetFilterRegion.newInstance(<BudgetFilterRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetFilterRegion) {
        if (!obj) return;

        models.BudgetFilterRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetFilterRegion): boolean {
        Object.setPrototypeOf(obj, BudgetFilterRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of region
     */
    type: string;

    /**
     * Id of the region
     */
    id: string;

    /**
     * Name of the region
     */
    name: string;

}
